export enum DaeStatusEnum {
  EMITIDO = 1,
  PAGO = 2,
  BAIXADO = 3
}

export const DaeStatusEnumAll = [
  { key: 'Emitido', value: DaeStatusEnum.EMITIDO },
  { key: 'Pago', value: DaeStatusEnum.PAGO },
  { key: 'Baixado', value: DaeStatusEnum.BAIXADO }
]
